import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';

const MarkdownComponents: object = {
  // Code will go here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  p: (paragraph: { children?: any; node?: any }) => {
    const { node } = paragraph;

    if (node.children[0].tagName === 'img') {
      const image = node.children[0];
      const metastring = image.properties.alt;
      const alt = metastring?.replace(/ *\{[^)]*\} */g, '');

      return (
        <div className="postImgWrapper">
          <img
            alt={alt}
            style={{ maxWidth: '100%', height: '100%', objectFit: 'contain' }}
            src={image.properties.src}
          />
          {alt ? (
            <div className="caption" aria-label={alt}>
              <span style={{ color: '#828282' }}>{alt}</span>
            </div>
          ) : null}
        </div>
      );
    }
    return <p>{paragraph.children}</p>;
  },
};

const Markdown = ({ children }: { children: string }) => {
  return (
    <ReactMarkdown remarkPlugins={[gfm]} components={MarkdownComponents}>
      {children}
    </ReactMarkdown>
  );
};

export default Markdown;
